import {
  string,
  number,
  object,
  array,
  optional,
  func,
  Infer,
  boolean,
} from 'superstruct';

export const ResultScoreSchema = object({
  matchId: number(),
  scores: string(),
  gameScore: string(),
  setScore: string(),
  extraSetScore: string(),
  service: string(),
  labelTime: string(),
});

export const SimulateSelectionSchema = object({
  selection_id: optional(string()),
  sport_name: optional(string()),
  sport_id: optional(string()),
  event_name: optional(string()),
  event_id: optional(string()),
  tournament_name: optional(string()),
  tournament_id: optional(string()),
  category_name: optional(string()),
  category_id: optional(string()),
  market_name: optional(string()),
  market_id: optional(string()),
  sign_name: optional(string()),
  sign_id: optional(string()),
  hnd: optional(string()),
  odd: optional(number()),
  result_scores: optional(ResultScoreSchema),
  is_live: optional(boolean()),
  match_time: optional(string()),
  game_score: optional(string()),
  scores: optional(string()),
  set_scores: optional(array(string())),
  match_id: optional(string()),
  raw_market_id: optional(string()),
  raw_outcome_id: optional(string()),
  odds: optional(number()),
});

export const SimulatePayloadSchema = object({
  // OTP Auth
  tenant_id: optional(string()),
  otp: optional(string()),
  stake: optional(number()),
  locale: optional(string()),
  source: optional(string()),
  page: optional(string()),
  selections: optional(array(SimulateSelectionSchema)),
  bet_type: optional(string()),
  // JWT Auth
  type: optional(string()),
  pm: optional(string()),
});

export const SimulateLaunchOptionsSchema = object({
  // OTP Auth
  selections: optional(array(SimulateSelectionSchema)),
  stake: optional(number()),
  bet_type: optional(string()),
  // JWT Auth
  payload: optional(string()),
});

export const SimulateConfigSchema = object({
  tenantId: optional(string()),
  iframeContainerId: string(),
  iframeSourceUrl: optional(string()),
  pageToRedirect: optional(string()),
  source: optional(string()),
  onRefreshBalance: optional(func()),
  onAnimationStart: optional(func()),
});

export type SimulateSelection = Infer<typeof SimulateSelectionSchema>;
export type SimulatePayload = Infer<typeof SimulatePayloadSchema>;

export type SimulateLaunchOptions = Infer<typeof SimulateLaunchOptionsSchema>;

export type SimulateConfig = Infer<typeof SimulateConfigSchema>;

/**
 * @deprecated
 */
export interface SimulateSDKInstance {
  simulateLaunch(options: SimulateLaunchOptions): Promise<void>;
  simulateUnmount(): Promise<void>;
}

export interface SimulateSDK {
  launch(options: SimulateLaunchOptions): Promise<void>;
  remove(): Promise<void>;
}
